import {
  ArrowLeftOutlined,
  ArrowUpOutlined,
  CaretDownFilled,
  CaretUpFilled,
  DeleteFilled,
  MailFilled,
  PhoneFilled,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Col,
  DatePicker,
  Divider,
  FloatButton,
  Form,
  Input,
  Row,
  Select,
  Space,
  Typography,
  Upload,
  message,
  theme,
} from "antd";
import { useForm } from "antd/es/form/Form";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Heading from "../../../components/common/heading";
import { ACCESS_TOKEN, SUCCESS_CODE } from "../../../lib/const";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import WithSidebar from "../../../templates/withSidebar";

import { APPCONFIG } from "../../../Config";
import ConfirmModal from "../../../components/modal/confirmModal";
import FailModal from "../../../components/modal/failModal";
import SuccessModal from "../../../components/modal/successModal";
import useContactReason from "../../../lib/hooks/useContactReason";

import useCountry from "../../../lib/hooks/useCountry";
import useKnowChannel from "../../../lib/hooks/useKnowChannel";
import useOfflineChannel from "../../../lib/hooks/useOfflineChannel";
import useOnlineChannel from "../../../lib/hooks/useOnlineChannel";
import { routes } from "../../../routes";
import APIEndpoint from "../../../services/endpoint";
import { downloadFile } from "../../../services/uploadFile";
import { ThaiDatePicker } from "../../../components/common/thaiDatePicker";

import axios from "axios";
import moment from "moment";
import {
  getStakeholderCustomer,
  updateStakeholderCustomer,
} from "../../../services/customerStakeholder";
import "./style.css";
import {MultipleAutoComplete} from "../../../components/common/autoCompleteV2";

const { useToken } = theme;
const { Option } = Select;

const { Text } = Typography;

const years = moment().format("YYYY");

const style1 = {
  padding: 15,
  marginBottom: 20,
  width: "80%",
  border: "1px solid #E5EAEE",
  borderRadius: 10,
};
const style2 = {
  padding: 15,
  marginBottom: 20,
  width: "80%",
  border: "1px solid #E5EAEE",
  borderRadius: 10,
  height: "100px",
  overflow: "hidden",
};

const EditStakeholder = () => {
  const navigate = useNavigate();
  const { token } = useToken();
  const params = useParams();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();

  const [form] = useForm();

  const [contactReason] = useContactReason();
  const [knownChannel] = useKnowChannel();
  const [onlineChannel] = useOnlineChannel();
  const [offlineChannel] = useOfflineChannel();
  const [countries] = useCountry();

  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);

  const [dataDatail, setDataDatail] = useState();

  const [textPhone, setTextPhone] = useState([]);
  const [textP, setTextP] = useState([]);
  const [textCounty, setTextCounty] = useState([]);
  const [textC, setTextC] = useState([]);
  const [textTopic, setTextTopic] = useState([]);

  const [textKnow, setTextKnow] = useState([]);

  const [textOnline, setTextOnline] = useState([]);

  const [textOffline, setTextOffline] = useState([]);

  const [confirmModal, setConfirmModal] = useState({
    type: "",
    show: false,
    name: "",
  });

  const [contactShowCSS, setContactShowCSS] = useState([]);

  const [fileList, setFileList] = useState([]);

  const [topicSelect, setTopicSelect] = useState([]);
  const [knownChannelSelect, setKnownChannelSelect] = useState([]);
  const [knownChannelOnlineSelect, setKnownChannelOnlineSelect] = useState([]);
  const [knownChannelOfflineSelect, setKnownChannelOfflineSelect] = useState(
    []
  );

  const [countriesSelect, setCountriesSelect] = useState([]);
  const [phoneNumb, setPhoneNumb] = useState(0);

  console.log("phone000", phoneNumb);
  console.log(
    "phone000",
    dataDatail?.stakeholdersContactPersonModel?.contactPersonPhoneDetail.length
  );
  const [topicMag, setTopiclMag] = useState(false);
  const onChangeTopic = (value) => {
    let checkMag = value.find(
      (v) => v === "965a18a0-1029-410b-9900-1c1d1c1fea47"
    );
    setTopicSelect(value);
    if (checkMag) {
      setTopiclMag(true);
    } else {
      setTopiclMag(false);
    }
  };

  const [knownChannelMag, setKnownChannelMag] = useState(false);
  const onChangeKnownChannel = (value) => {
    setKnownChannelSelect(value);
    let checkMag = value.find(
      (v) => v === "a3892b82-daf6-c046-2b96-4fcd313f0461"
    );

    if (checkMag) {
      setKnownChannelMag(true);
    } else {
      setKnownChannelMag(false);
    }
  };

  const [onChannelMag, setOnChannelMag] = useState(false);
  const onChangeOn = (value) => {
    setKnownChannelOnlineSelect(value);
    let checkOnMag = value.find(
      (v) => v === "45cb5964-3e68-8a89-f7d8-12426a461afd"
    );

    if (checkOnMag) {
      setOnChannelMag(true);
    } else {
      setOnChannelMag(false);
    }
  };

  const [offChannelMag, setOffChannelMag] = useState(false);
  const onChangeOff = (value) => {
    setKnownChannelOfflineSelect(value);

    let checkOffMag = value.find(
      (v) => v === "15fffb13-7472-9e63-ed28-7282932f48ba"
    );

    if (checkOffMag) {
      setOffChannelMag(true);
    } else {
      setOffChannelMag(false);
    }
  };

  const stakeholderCustomer = useCallback(
    async (id) => {
      const res = await getStakeholderCustomer(id);
      if (res.data.code === "0000") {
        const { objectValue } = res.data;
        setPhoneNumb(
          objectValue?.stakeholdersContactPersonModel?.contactPersonPhoneDetail
            .length
        );

        let files = [];

        let arrCon = [];
        // eslint-disable-next-line array-callback-return
        objectValue?.stakeholdersStaffFollowUpModels.map((item) => {
          arrCon.push({
            contactDate: moment(
              moment(item?.customerDate).format("MM/DD/YYYY HH:mm")
            ),

            staffName: item.staffName,
            staffDetail: item.staffDetail,

            filePath: item.filePath,
            staffFollowUp: item.staffFollowUp,
          });
        });

        // if (arrCon.length > 0) {
        //   for (let a = 0; a < arrCon.length; a++) {
        //     setContactShowCSS([
        //       ...contactShowCSS,
        //       { no: contactShowCSS.length + 1, statusShow: false },
        //     ]);
        //   }
        // }
        let showStaff = [];
        if (arrCon.length > 0) {
          for (let a = 0; a < arrCon.length; a++) {
            showStaff.push({
              no: a,
              statusShow: true,
            });
          }
        }

        setContactShowCSS(showStaff);

        if (arrCon.length > 0) {
          for (let a = 0; a < arrCon.length; a++) {
            const res = await downloadFile(arrCon[a].filePath);
            files.push({
              index: a,

              filePath: res?.data?.objectValue?.filePath || arrCon[a].filePath,

              file: res?.data?.objectValue?.fileName,
              name: res?.data?.objectValue?.fileName,
              status: "done",

              url: "",
            });
          }
        }
        setFileList(files);

        form.setFieldsValue({
          contact: arrCon.reverse(),
        });

        setDataDatail(objectValue);

        form.setFieldsValue({
          yearOfBudget: objectValue?.yearOfBudget,

          customerDate: moment(
            moment(objectValue?.customerDate).format("MM/DD/YYYY HH:mm")
          ),
          customerType: objectValue?.customerType,

          companyNameTH: objectValue?.stakeholdersCompanyModel?.companyNameTH,
          companyNameEN: objectValue?.stakeholdersCompanyModel?.companyNameEN,
          companyAddress: objectValue?.stakeholdersCompanyModel?.companyAddress,
          companyEmail: objectValue?.stakeholdersCompanyModel?.companyEmail,
          companyPhone: objectValue?.stakeholdersCompanyModel?.companyPhone,
          companyWebsite: objectValue?.stakeholdersCompanyModel?.companyWebsite,

          contactName: objectValue?.stakeholdersContactPersonModel?.contactName,
          contactPosition:
            objectValue?.stakeholdersContactPersonModel?.contactPosition,
          contactEmail:
            objectValue?.stakeholdersContactPersonModel?.contactEmail,
          interestedArea:
            objectValue?.stakeholdersContactPersonModel?.interestedArea,
          areaAuthoritySuggested:
            objectValue?.stakeholdersContactPersonModel?.areaAuthoritySuggested,
          needsSatisfaction:
            objectValue?.stakeholdersContactPersonModel?.needsSatisfaction,
          contactPhoneList:
            objectValue?.stakeholdersContactPersonModel?.contactPhoneList,
          requirementExpectationVoc:
            objectValue?.stakeholdersContactPersonModel
              ?.requirementExpectationVoc,

          stakeholdersStaffFollowUpModels:
            objectValue?.stakeholdersStaffFollowUpModels,
          // nationalityList: objectValue?.stakeholdersContactPersonModel?.contactPersonNationalityDetail,
        });

        let arrPhone = [];
        let arrPhoneText = [];

        if (
          objectValue?.stakeholdersContactPersonModel?.contactPersonPhoneDetail
            .length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonPhoneDetail.length;
            a++
          ) {
            arrPhone.push({
              contactPhone:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPhoneDetail[a].contactPhone,
            });
          }
        }

        if (
          objectValue?.stakeholdersContactPersonModel?.contactPersonPhoneDetail
            .length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonPhoneDetail.length;
            a++
          ) {
            arrPhoneText.push(
              objectValue?.stakeholdersContactPersonModel
                ?.contactPersonPhoneDetail[a].contactPhone
            );
          }
        }

        let arrCounty = [];
        let arrCountyText = [];

        if (
          objectValue?.stakeholdersContactPersonModel
            ?.contactPersonNationalityDetail.length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonNationalityDetail.length;
            a++
          ) {
            arrCounty.push({
              countryNameEn:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonNationalityDetail[a].masterCountryDetail
                  ?.countryNameEn,
              countryNameTh:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonNationalityDetail[a].masterCountryDetail
                  ?.countryNameTh,
            });
          }
        }
        if (
          objectValue?.stakeholdersContactPersonModel
            ?.contactPersonNationalityDetail.length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonNationalityDetail.length;
            a++
          ) {
            arrCountyText.push(
              objectValue?.stakeholdersContactPersonModel
                ?.contactPersonNationalityDetail[a].masterCountryDetail
                ?.countryId
            );
          }
        }

        let arrTopic = [];
        let arrTopicText = [];

        if (objectValue?.stakeholdersTopicModels.length > 0) {
          for (
            let a = 0;
            a < objectValue?.stakeholdersTopicModels.length;
            a++
          ) {
            arrTopic.push({
              stakeholdersTopicId:
                objectValue?.stakeholdersTopicModels[a].stakeholdersTopicId,
              stakeholdersId:
                objectValue?.stakeholdersTopicModels[a].stakeholdersId,
              topicId: objectValue?.stakeholdersTopicModels[a].topicId,
              topicOther: objectValue?.stakeholdersTopicModels[a].topicOther,
            });
            if (
              objectValue?.stakeholdersTopicModels[a].topicId ===
              "965a18a0-1029-410b-9900-1c1d1c1fea47"
            ) {
              form.setFieldsValue({
                topicOther: objectValue?.stakeholdersTopicModels[a].topicOther,
              });
            }
          }
        }
        if (objectValue?.stakeholdersTopicModels.length > 0) {
          for (
            let a = 0;
            a < objectValue?.stakeholdersTopicModels.length;
            a++
          ) {
            arrTopicText.push(objectValue?.stakeholdersTopicModels[a].topicId);
          }
        }

        let arrKnow = [];
        let arrKnowText = [];

        if (
          objectValue?.stakeholdersContactPersonModel
            ?.contactPersonReferredDetail.length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonReferredDetail.length;
            a++
          ) {
            arrKnow.push({
              stakeholdersContactPersonReferredId:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonReferredDetail[a]
                  .stakeholdersContactPersonReferredId,
              stakeholdersContactPersonId:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonReferredDetail[a].stakeholdersContactPersonId,
              referredById:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonReferredDetail[a].referredById,
              referredByOther:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonReferredDetail[a].referredByOther,
            });

            if (
              objectValue?.stakeholdersContactPersonModel
                ?.contactPersonReferredDetail[a].referredById ===
              "a3892b82-daf6-c046-2b96-4fcd313f0461"
            ) {
              form.setFieldsValue({
                knownChannelDetail:
                  objectValue?.stakeholdersContactPersonModel
                    ?.contactPersonReferredDetail[a].referredByOther,
              });
            }
          }
        }
        if (
          objectValue?.stakeholdersContactPersonModel
            ?.contactPersonReferredDetail.length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonReferredDetail.length;
            a++
          ) {
            arrKnowText.push(
              objectValue?.stakeholdersContactPersonModel
                ?.contactPersonReferredDetail[a].referredById
            );
          }
        }

        let arrOn = [];
        let arrOnText = [];

        if (
          objectValue?.stakeholdersContactPersonModel
            ?.contactPersonPreferenceOnlineDetail.length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonPreferenceOnlineDetail.length;
            a++
          ) {
            arrOn.push({
              stakeholdersContactPersonPreferenceOnlineId:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPreferenceOnlineDetail[a]
                  .stakeholdersContactPersonPreferenceOnlineId,
              stakeholdersContactPersonId:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPreferenceOnlineDetail[a]
                  .stakeholdersContactPersonId,
              contactPreferenceOnlineId:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPreferenceOnlineDetail[a]
                  .contactPreferenceOnlineId,
              contactPreferenceOnlineOther:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPreferenceOnlineDetail[a]
                  .contactPreferenceOnlineOther,
            });
            if (
              objectValue?.stakeholdersContactPersonModel
                ?.contactPersonPreferenceOnlineDetail[a]
                .contactPreferenceOnlineId ===
              "45cb5964-3e68-8a89-f7d8-12426a461afd"
            ) {
              form.setFieldsValue({
                knownChannelOnlineDetail:
                  objectValue?.stakeholdersContactPersonModel
                    ?.contactPersonPreferenceOnlineDetail[a]
                    .contactPreferenceOnlineOther,
              });
            }
          }
        }

        if (
          objectValue?.stakeholdersContactPersonModel
            ?.contactPersonPreferenceOnlineDetail.length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonPreferenceOnlineDetail.length;
            a++
          ) {
            arrOnText.push(
              objectValue?.stakeholdersContactPersonModel
                ?.contactPersonPreferenceOnlineDetail[a]
                .contactPreferenceOnlineId
            );
          }
        }

        let arrOff = [];
        let arrOffText = [];

        if (
          objectValue?.stakeholdersContactPersonModel
            ?.contactPersonPreferenceOfflineDetail.length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonPreferenceOfflineDetail.length;
            a++
          ) {
            arrOff.push({
              stakeholdersContactPersonPreferenceOfflineId:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPreferenceOfflineDetail[a]
                  .stakeholdersContactPersonPreferenceOfflineId,
              stakeholdersContactPersonId:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPreferenceOfflineDetail[a]
                  .stakeholdersContactPersonId,
              contactPreferenceOfflineId:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPreferenceOfflineDetail[a]
                  .contactPreferenceOfflineId,
              contactPreferenceOfflineOther:
                objectValue?.stakeholdersContactPersonModel
                  ?.contactPersonPreferenceOfflineDetail[a]
                  .contactPreferenceOfflineOther,
            });

            if (
              objectValue?.stakeholdersContactPersonModel
                ?.contactPersonPreferenceOfflineDetail[a]
                .contactPreferenceOfflineId ===
              "15fffb13-7472-9e63-ed28-7282932f48ba"
            ) {
              form.setFieldsValue({
                knownChannelOfflineDetail:
                  objectValue?.stakeholdersContactPersonModel
                    ?.contactPersonPreferenceOfflineDetail[a]
                    .contactPreferenceOfflineOther,
              });
            }
          }
        }
        if (
          objectValue?.stakeholdersContactPersonModel
            ?.contactPersonPreferenceOfflineDetail.length > 0
        ) {
          for (
            let a = 0;
            a <
            objectValue?.stakeholdersContactPersonModel
              ?.contactPersonPreferenceOfflineDetail.length;
            a++
          ) {
            arrOffText.push(
              objectValue?.stakeholdersContactPersonModel
                ?.contactPersonPreferenceOfflineDetail[a]
                .contactPreferenceOfflineId
            );
          }
        }
        console.log("arrPhone", arrPhone);
        form.setFieldsValue({
          topicList: arrTopicText,
          knownChannel: arrKnowText,
          knownChannelOnline: arrOnText,
          knownChannelOffline: arrOffText,
          nationalityList: arrCountyText,
          phoneList: arrPhone.reverse(),
        });

        setTextPhone(arrPhone);
        setTextP(arrPhoneText);
        setTextCounty(arrCounty);
        setTextC(arrCountyText);
        setTextKnow(arrKnow);

        setTextTopic(arrTopic);

        setTextOnline(arrOn);

        setTextOffline(arrOff);
        onChangeTopic(arrTopicText);
        onChangeKnownChannel(arrKnowText);
        onChangeOn(arrOnText);
        onChangeOff(arrOffText);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form]
  );

  useEffect(() => {
    stakeholderCustomer(params.id);
  }, [params.id, stakeholderCustomer]);

  const onChangePage = () => {
    setOpenCancelModal(true);
    navigate(routes.customer_tab_stakeholder, {
      state: {},
    });
  };

  const onFinish = async (values) => {
    let arrCon1 = [];
    console.log("arrCon1", arrCon1);
    console.log("values", values);
    console.log("ddd", values.contact.length);
    console.log(
      "stakeholdersStaffFollowUpId",
      3,
      "dddd",
      dataDatail?.stakeholdersStaffFollowUpModels.length
    );
    if (values.contact) {
      const existingRows =
        dataDatail?.stakeholdersStaffFollowUpModels.length || 0;
      const missingFileRows = values.contact
        .map((_c, a) => a)
        .filter((a) => a >= existingRows && !fileList[a]?.filePath);
      if (missingFileRows.length > 0) {
        form.setFields(
          missingFileRows.map((a) => ({
            name: ["contact", a, "upload_file"],
            errors: ["โปรดระบุ"],
          }))
        );
        return;
      }
      for (let a = 0; a < values.contact.length; a++) {
        console.log("ooooyyyy11111", a);
        if (a >= dataDatail?.stakeholdersStaffFollowUpModels.length) {
          console.log("ooooyyyy22222", a);
          arrCon1.push({
            contactDate: values.contact[a].contactDate.format("DD/MM/YYYY"),
            staffName: values.contact[a].staffName,
            staffDetail: values.contact[a].staffDetail,

            filePath: fileList[a]?.filePath || "",
            staffFollowUp: values.contact[a].staffFollowUp,
          });
        } else {
          console.log("ooooyyyy3333", a);
          arrCon1.push({
            stakeholdersStaffFollowUpId:
              dataDatail?.stakeholdersStaffFollowUpModels[a]
                .stakeholdersStaffFollowUpId,
            stakeholdersId:
              dataDatail?.stakeholdersStaffFollowUpModels[a].stakeholdersId,
            contactDate: values.contact[a].contactDate.format("DD/MM/YYYY"),
            staffName: values.contact[a].staffName,
            staffDetail: values.contact[a].staffDetail,

            filePath: fileList[a]?.filePath || "",
            staffFollowUp: values.contact[a].staffFollowUp,
          });
        }
      }
    }

    let arrReason = [];
    if (topicSelect) {
      for (let a = 0; a < topicSelect.length; a++) {
        const conReason = contactReason.filter(
          (v) => v.dataId === values.topicList[a]
        )[0];

        arrReason.push({
          // stakeholdersTopicId:
          //   dataDatail?.stakeholdersTopicModels[a].stakeholdersTopicId,
          stakeholdersId: dataDatail?.stakeholdersId,
          topicId: topicSelect[a],
          topicOther:
            topicSelect[a] === "965a18a0-1029-410b-9900-1c1d1c1fea47"
              ? values.topicOther
              : "",
        });
      }
    }

    let arrAuthority = [];
    if (knownChannelSelect) {
      for (let a = 0; a < knownChannelSelect.length; a++) {
        arrAuthority.push({
          stakeholdersId: dataDatail?.stakeholdersId,
          referredById: knownChannelSelect[a],
          referredByOther:
            knownChannelSelect[a] === "a3892b82-daf6-c046-2b96-4fcd313f0461"
              ? values.knownChannelDetail
              : "",
        });
      }
    }

    let arrOn = [];
    if (knownChannelOnlineSelect) {
      for (let b = 0; b < knownChannelOnlineSelect.length; b++) {
        arrOn.push({
          stakeholdersId: dataDatail?.stakeholdersId,
          contactPreferenceOnlineId: knownChannelOnlineSelect[b],
          contactPreferenceOnlineOther:
            knownChannelOnlineSelect[b] ===
            "45cb5964-3e68-8a89-f7d8-12426a461afd"
              ? values.knownChannelOnlineDetail
              : "",
        });
      }
    }

    let arrOff = [];
    if (knownChannelOfflineSelect) {
      for (let b = 0; b < knownChannelOfflineSelect.length; b++) {
        arrOff.push({
          stakeholdersId: dataDatail?.stakeholdersId,
          contactPreferenceOfflineId: knownChannelOfflineSelect[b],
          contactPreferenceOfflineOther:
            knownChannelOfflineSelect[b] ===
            "15fffb13-7472-9e63-ed28-7282932f48ba"
              ? values.knownChannelOfflineDetail
              : "",
        });
      }
    }
    let arrPhoneList = [];
    if (values.phoneList) {
      for (let b = 0; b < values.phoneList.length; b++) {
        arrPhoneList.push(values.phoneList[b].contactPhone);
      }
    }

    console.log("arrPhoneList", arrPhoneList);
    const payload = {
      stakeholdersId: dataDatail?.stakeholdersId,
      stakeholdersContactPersonId: dataDatail?.stakeholdersContactPersonId,
      yearOfBudget: dataDatail?.yearOfBudget,
      customerDate: moment(new Date(dataDatail?.customerDate)).format(
        "DD/MM/YYYY"
      ),
      customerType: dataDatail?.customerType,

      stakeholdersCompanyId:
        dataDatail?.stakeholdersCompanyModel?.stakeholdersCompanyId,

      stakeholdersCompanyDetail: {
        stakeholdersCompanyId: dataDatail?.stakeholdersCompanyId,
        stakeholdersId: dataDatail?.stakeholdersId,
        // companyNameTH: dataDatail?.stakeholdersCompanyModel?.companyNameTH,
        // companyNameEN: dataDatail?.stakeholdersCompanyModel?.companyNameEN,
        // companyAddress: dataDatail?.stakeholdersCompanyModel?.companyAddress,
        // companyEmail: dataDatail?.stakeholdersCompanyModel?.companyEmail,
        // companyPhone: dataDatail?.stakeholdersCompanyModel?.companyPhone,
        // companyWebsite: dataDatail?.stakeholdersCompanyModel?.companyWebsite,
        companyNameTH: values.companyNameTH,
        companyNameEN: values.companyNameEN,
        companyAddress: values.companyAddress,
        companyEmail: values.companyEmail,
        companyPhone: values.companyPhone,
        companyWebsite: values.companyWebsite,
      },
      stakeholdersContactPersonDetail: {
        stakeholdersContactPersonId: dataDatail?.stakeholdersContactPersonId,
        stakeholdersId: dataDatail?.stakeholdersId,
        contactName: values.contactName,
        contactPosition: values.contactPosition,
        contactEmail: values.contactEmail,
        areaAuthoritySuggested: values.areaAuthoritySuggested,
        needsSatisfaction: values.needsSatisfaction,
        interestedArea: values.interestedArea,
        requirementExpectationVoc: values.requirementExpectationVoc,
        contactPhoneList: arrPhoneList,
        nationalityList: textC,
        contactPreferenceOnlineList: arrOn,

        contactPreferenceOfflineList: arrOff,

        referredList: arrAuthority,
      },
      stakeholdersStaffFollowUpDetail: arrCon1,

      topicList: arrReason,
    };
    console.log("payload", payload);

    const res = await updateStakeholderCustomer(payload);

    if (res.data.code === SUCCESS_CODE) {
      setSuccessModal(true);

      setTimeout(() => {
        navigate(routes.customer);
        setSuccessModal(false);
        navigate(routes.customer_tab_stakeholder, {
          state: {},
        });
      }, 2000);
    } else {
      setFailModal(true);
      setTimeout(() => {
        setFailModal(false);
        navigate(routes.customer_tab_stakeholder, {
          state: {},
        });
      }, 2000);
    }
  };

  const onUploadFile = async (info, index) => {
    const newObj = {
      index: index,
      file: info.file.name,
      name: info.file.name,
      filePath: "",
      status: "uploading",
      uid: info.file.uid,
      url: "",
    };

    let formData = new FormData();
    formData.append("file", info.file);

    const api = APIEndpoint.UPLOAD_FILE_API;
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        "content-type": "multipart/form-data",
      },
    };
    const res = await axios.post(
      APPCONFIG.GATEWAY_ENDPOINT + api,
      formData,
      config
    );
    if (res?.data?.code === SUCCESS_CODE) {
      message.success(`${res.data.message}`);
      const { objectValue } = res.data;
      newObj.status = "done";
      newObj.file = objectValue.fileName;
      newObj.name = objectValue.fileName;
      newObj.filePath = objectValue.filePath;

      if (fileList.length === 0) {
        setFileList([newObj]);
      } else {
        let newData = fileList.filter((item) => item.index !== index);
        newData.push(newObj);
        setFileList(newData);
      }
      form.setFields([
        {
          name: ["filePath", index],
          value: objectValue.filePath,
        },
      ]);
    } else {
      newObj.status = "error";

      message.error(`${res.data.message}`);
    }
  };

  const onRemoveFile = (info, index) => {
    form.setFields([
      {
        name: ["filePath", index],
        value: "",
      },
    ]);
    let newData = fileList.filter((item) => item.index !== index);
    setFileList(newData);
  };

  const collapseElems = (id) => {
    const newState = contactShowCSS.map((obj) => {
      if (obj.no === id) {
        return { ...obj, statusShow: !obj.statusShow };
      }

      return obj;
    });

    setContactShowCSS(newState);
  };

  const addPhone = (a) => {
    setPhoneNumb(Number(a) + 1);
    console.log("rrrr");
  };
  const removePhone = (a) => {
    setPhoneNumb(Number(a) - 1);
    console.log("rrrr111");
  };
  const changeNation = (b) => {
    let nationChange = [b];
    setTextC(nationChange);
  };
  console.log("addPhone", phoneNumb);

  return (
    <WithSidebar>
      <div>
        <FloatButton.BackTop
          className="custom-float-btn"
          icon={<ArrowUpOutlined style={{ color: "#fff" }} />}
          shape="square"
          style={{ backgroundColor: "#499D96 !important", color: "#fff" }}
        />
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={onChangePage}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"แก้ไขข้อมูล"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "ผู้มีส่วนได้ส่วนเสีย",
                },
                {
                  title: "รายละเอียด",
                },
                {
                  title: <span className="pr_green">แก้ไขข้อมูล</span>,
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              style={{ width: "100%", padding: "0 30px" }}
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      onClick={() => {
                        setOpenCancelModal(true);
                        setPreviousPage(routes.customer_tab_stakeholder);
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button type="primary" htmlType="submit">
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>

              <Row gutter={[24, 16]} className="card">
                <Col span={24}>
                  <Heading
                    text="ข้อมูลผู้มีส่วนได้ส่วนเสีย"
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Col className="gutter-row" span={8}>
                  <Form.Item
                    label="ปีงบประมาณ"
                    name="yearOfBudget"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select placeholder="" disabled>
                      {(() => {
                        let arr = [];

                        for (let i = 0; i < 5; i++) {
                          arr.push(
                            <Option
                              value={parseInt(years - i)}
                              selected={years === 2023 ? true : false}
                            >
                              {parseInt(years) + 544 - i}
                            </Option>
                          );
                        }
                        return arr;
                      })()}
                    </Select>
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={8}>
                  <Form.Item
                    label="วัน/เดือน/ปี ที่รับลูกค้า"
                    name="customerDate"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <ThaiDatePicker
                      style={{ width: "100%" }}
                      disabled
                    />
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Row gutter={[16, 24]}>
                    <Col className="gutter-row" span={12}>
                      <Form.Item label="ประเภทผู้ติดต่อ" name="customerType">
                        <Select placeholder="ประเภทผู้ติดต่อ" disabled>
                          <Option value={"หน่วยงานผู้มีส่วนได้ส่วนเสีย"}>
                            หน่วยงานผู้มีส่วนได้ส่วนเสีย
                          </Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ประเด็นติดต่อต่าง ๆ (ตอบได้มากกว่า 1 ข้อ)"
                    name="topicList"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      placeholder="ประเด็นติดต่อต่าง ๆ (ตอบได้มากกว่า 1 ข้อ)"
                      onChange={(value) => onChangeTopic(value)}
                    >
                      {contactReason.map((item) => (
                        <Option value={item.dataId}>{item.dataDetailTh}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {topicMag === true && (
                  <Col className="gutter-row" span={16}>
                    <Form.Item
                      label=""
                      name="topicOther"
                      style={{ marginTop: 8 }}
                    >
                      <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                    </Form.Item>
                  </Col>
                )}
              </Row>

              <Row gutter={[24, 16]} className="card" style={{ marginTop: 15 }}>
                <Col span={24}>
                  <Heading
                    text="ข้อมูลบริษัท"
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ชื่อบริษัท (TH)"
                    name="companyNameTH"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ชื่อบริษัท (EN)"
                    name="companyNameEN"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ที่อยู่บริษัท"
                    name="companyAddress"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "โปรดระบุ",
                    //   },
                    // ]}
                  >
                    <Input.TextArea />
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Row gutter={[16, 24]}>
                    <Col className="gutter-row" span={12}>
                      <Form.Item
                        label="Email บริษัท"
                        name="companyEmail"
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: "โปรดระบุ",
                        //   },
                        // ]}
                      >
                        <Input prefix={<MailFilled />} />
                      </Form.Item>
                    </Col>

                    <Col className="gutter-row" span={12}>
                      <Form.Item
                        label="เบอร์โทรศัพท์ผู้ติดต่อ"
                        name="companyPhone"
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: "โปรดระบุ",
                        //   },
                        // ]}
                      >
                        <Input prefix={<PhoneFilled />} />
                      </Form.Item>
                    </Col>

                    <Col className="gutter-row" span={12}>
                      <Form.Item
                        label="Website"
                        name="companyWebsite"
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: "โปรดระบุ",
                        //   },
                        // ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={[24, 16]} className="card" style={{ marginTop: 15 }}>
                <Col span={24}>
                  <Heading
                    text={"ข้อมูลผู้ติดต่อ (Contact Person)"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Col className="gutter-row" span={8}>
                  <Form.Item
                    label="ชื่อ-นามสกุล"
                    name="contactName"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={8}>
                  <Form.Item
                    label="ตำแหน่ง"
                    name="contactPosition"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Row gutter={[16, 16]}>
                    <Col className="gutter-row" span={8}>
                      <Form.Item
                        name="contactEmail"
                        label="Email บริษัท"
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input prefix={<MailFilled />} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                {/* <Col span={24}>
                  <Row gutter={[16, 16]}>
                    <Col className="gutter-row" span={8}>
                      <Form.Item
                        label="เบอร์โทรศัพท์ผู้ติดต่อ"
                        name=""
                        rules={[
                          {
                            required: false,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        {textPhone?.map((item, i) => {
                          return (
                            <>
                              <Input
                                prefix={<PhoneFilled />}
                                placeholder={item.phone}
                              />

                              <br />
                            </>
                          );
                        })}
                      </Form.Item>
                    </Col>
                  </Row>
                </Col> */}
                <Col className="gutter-row" span={8}>
                  <Form.Item
                    label="เบอร์โทรศัพท์ผู้ติดต่อ"
                    name=""
                    rules={[
                      {
                        required: false,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Form.List name={"phoneList"}>
                      {(fields, { add, remove }) => {
                        const newCF = () => {
                          setContactShowCSS([
                            ...contactShowCSS,
                            {
                              no: contactShowCSS.length + 1,
                              statusShow: false,
                            },
                          ]);

                          add();
                        };

                        return (
                          <>
                            {fields.map(({ key, name, ...restField }) => (
                              <Col key={key} span={24}>
                                <div
                                  style={{
                                    position: "absolute",
                                    right: "120px",
                                    bottom: "25px",
                                  }}
                                >
                                  {key === 0 ? null : (
                                    <>
                                      <Button
                                        shape="circle"
                                        size="small"
                                        style={{
                                          backgroundColor: "#FDE7E5",
                                          border: 0,
                                          marginTop: "-15px",
                                          marginLeft: "140px",
                                          position: "absolute",
                                        }}
                                        onClick={() => {
                                          remove(name);
                                          removePhone(phoneNumb);
                                        }}
                                      >
                                        <DeleteFilled
                                          style={{ color: "#F04438" }}
                                        />
                                      </Button>
                                    </>
                                  )}
                                </div>
                                <div
                                  className={`relative`}
                                  // style={
                                  //   contactShowCSS[key].statusShow === true
                                  //     ? style2
                                  //     : style1
                                  // }
                                >
                                  <Row>
                                    <Col className="gutter-row" span={24}>
                                      <Form.Item
                                        {...restField}
                                        label=""
                                        style={{ marginBottom: "10px" }}
                                        name={[name, "contactPhone"]}
                                        rules={[
                                          {
                                            required: true,
                                            message: "โปรดระบุ",
                                          },
                                        ]}
                                      >
                                        <Input
                                          prefix={<PhoneFilled />}
                                          // placeholder={item.phone}
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                            ))}
                            <ConfirmModal
                              actionType={"delete"}
                              title={"ยืนยันการลบข้อมูล"}
                              modalText={"คุณต้องการลบข้อมูล ?"}
                              open={
                                confirmModal.type === "delete"
                                  ? confirmModal.show
                                  : false
                              }
                              onOk={() => {
                                remove(confirmModal.name);
                                setConfirmModal({
                                  type: "",
                                  show: false,
                                  name: "",
                                });
                              }}
                              onCancel={() => {
                                setConfirmModal({
                                  type: "",
                                  show: false,
                                  name: "",
                                });
                              }}
                            />
                            <Col span={24}>
                              {/* <Button
                                style={{
                                  background: "#2E90FA",
                                  color: "#fff",
                                  fontWeight: 500,
                                }}
                                onClick={() => add()}
                              >
                                <PlusOutlined /> เพิ่ม
                              </Button> */}
                              {phoneNumb > 2 ? null : (
                                <Button
                                  type="link"
                                  style={{ fontWeight: 600 }}
                                  onClick={() => {
                                    add();
                                    addPhone(phoneNumb);
                                  }}
                                >
                                  <PlusOutlined /> เบอร์โทรศัพท์ผู้ติดต่อ
                                </Button>
                              )}
                            </Col>{" "}
                          </>
                        );
                      }}
                    </Form.List>
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Row gutter={[16, 16]}>
                    <Col className="gutter-row" span={8}>
                      <Form.Item
                        label="สัญชาติ"
                        name="nationalityList"
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        {/* <Select
                          placeholder="กรุณาเลือก"
                          // mode="multiple"
                          onChange={(value) => changeNation(value)}
                        >
                          {countries.map((item) => (
                            <Option value={item.countryId}>
                              {item.countryNameTh}
                            </Option>
                          ))}
                        </Select> */}
                        <MultipleAutoComplete
                          multiple={false}
                          subject="countryOrderNameTh"
                          valueField="countryId"
                          labelField="countryNameTh"
                          placeholder="กรุณาเลือก"
                          onChange={(value) => changeNation(value)}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="พื้นที่นิคมฯที่สนใจ/กนอ. แนะนำ"
                    name="areaAuthoritySuggested"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input.TextArea
                    // placeholder={
                    //   dataDatail?.stakeholdersContactPersonModel
                    //     ?.contactPersonReferredDetail[0].masterDataDetail
                    //     ?.dataDetailTh
                    // }
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ความต้องการ/ความคาดหวัง/ความพึงพอใจต่อผลิตภัณฑ์"
                    name="needsSatisfaction"
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input.TextArea placeholder="" />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ช่องทางที่รู้จัก กนอ. (ตอบได้มากกว่า 1 ข้อ)"
                    name="knownChannel"
                  >
                    <Select
                      mode="multiple"
                      placeholder="กรุณาเลือก"
                      onChange={(value) => onChangeKnownChannel(value)}
                    >
                      {knownChannel.map((item) => (
                        <Option value={item.dataId}>{item.dataDetailTh}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {knownChannelMag === true && (
                    <Form.Item
                      label=""
                      name="knownChannelDetail"
                      style={{ marginTop: 8 }}
                    >
                      <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                    </Form.Item>
                  )}
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ช่องทางที่ใช้ติดต่อ กนอ. ONLINE (ตอบได้มากกว่า 1 ข้อ)"
                    name="knownChannelOnline"
                  >
                    <Select
                      mode="multiple"
                      placeholder="กรุณาเลือก"
                      onChange={(value) => onChangeOn(value)}
                    >
                      {onlineChannel.map((item) => (
                        <Option value={item.dataId}>{item.dataDetailTh}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {onChannelMag === true && (
                    <Form.Item
                      label=""
                      name="knownChannelOnlineDetail"
                      style={{ marginTop: 8 }}
                    >
                      <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                    </Form.Item>
                  )}
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ช่องทางที่ใข้ติดต่อ กนอ. OFFLINE (ตอบได้มากกว่า 1 ข้อ)"
                    name="knownChannelOffline"
                  >
                    <Select
                      mode="multiple"
                      placeholder="กรุณาเลือก"
                      onChange={(value) => onChangeOff(value)}
                    >
                      {offlineChannel.map((item) => (
                        <Option value={item.dataId}>{item.dataDetailTh}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {offChannelMag === true && (
                    <Form.Item
                      label=""
                      name="knownChannelOfflineDetail"
                      style={{ marginTop: 8 }}
                    >
                      <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                    </Form.Item>
                  )}
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="พื้นที่ที่สนใจ"
                    name="interestedArea"
                    // rules={[{ required: true, message: "โปรดระบุ" }]}
                  >
                    <Input.TextArea placeholder="" />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={16}>
                  <Form.Item
                    label="ความต้องการ/ความคาดหวัง/VOC"
                    name="requirementExpectationVoc"
                    rules={[{ required: true, message: "โปรดระบุ" }]}
                  >
                    <Input.TextArea placeholder="" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[24, 16]} className="card" style={{ marginTop: 15 }}>
                <Col span={24}>
                  <Heading
                    text={"สรุปการติดต่อรายครั้ง"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Form.List name={"contact"}>
                  {(fields, { add, remove }) => {
                    const removeCF = (name) => {
                      setConfirmModal({
                        type: "delete",
                        show: true,
                        name: name,
                      });
                    };
                    const newCF = () => {
                      setContactShowCSS([
                        ...contactShowCSS,
                        { no: contactShowCSS.length + 1, statusShow: false },
                      ]);

                      add();
                    };

                    return (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <Col key={key} span={24}>
                            <div
                              style={{
                                position: "absolute",
                                right: "120px",
                                bottom: "25px",
                              }}
                            >
                              <Button
                                shape="circle"
                                size="small"
                                style={{
                                  backgroundColor: "#FDE7E5",
                                  border: 0,
                                }}
                                onClick={() => removeCF(name)}
                              >
                                <DeleteFilled style={{ color: "#F04438" }} />
                              </Button>
                              <Button
                                shape="circle"
                                size="small"
                                style={{
                                  backgroundColor: "#F4F6FC",
                                  border: 0,
                                  marginLeft: 5,
                                }}
                                onClick={() => collapseElems(key)}
                              >
                                {!contactShowCSS[key].statusShow ? (
                                  <CaretUpFilled
                                    style={{
                                      color: "#2E90FA",
                                      fontSize: 16,
                                    }}
                                  />
                                ) : (
                                  <CaretDownFilled
                                    style={{
                                      color: "#2E90FA",
                                      fontSize: 16,
                                    }}
                                  />
                                )}
                              </Button>
                            </div>
                            <div
                              className={`relative`}
                              style={
                                contactShowCSS[key].statusShow === true
                                  ? style2
                                  : style1
                              }
                            >
                              <Row gutter={[24, 16]}>
                                <Col className="gutter-row" span={12}>
                                  <Form.Item
                                    {...restField}
                                    label="วัน/เดือน/ปี ที่ติดต่อ"
                                    name={[name, "contactDate"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                    <ThaiDatePicker
                                      style={{ width: "100%" }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                  <Form.Item
                                    {...restField}
                                    label="ชื่อเจ้าหน้าที่"
                                    name={[name, "staffName"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                    <Input placeholder="ชื่อเจ้าหน้าที่" />
                                  </Form.Item>
                                </Col>

                                <Col className="gutter-row" span={24}>
                                  <Form.Item
                                    {...restField}
                                    label="รายละเอียดการติดต่อ"
                                    name={[name, "staffDetail"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                    <Input.TextArea placeholder="รายละเอียด" />
                                  </Form.Item>
                                </Col>

                                <Col span={16}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "upload_file"]}
                                    label={"แนบไฟล์"}
                                    required={true}
                                    rules={[
                                      {
                                        required:
                                          fileList.length > 0 ? false : true,
                                        message: "โปรดระบุ",
                                      },
                                    ]}
                                  >
                                    <Upload
                                      customRequest={(e) => {
                                        onUploadFile(e, key);
                                      }}
                                      onRemove={(info) => {
                                        onRemoveFile(info, key);
                                      }}
                                      fileList={
                                        fileList.length > 0
                                          ? fileList.filter(
                                              (obj, index) =>
                                                fileList.findIndex(
                                                  (item) =>
                                                    item.uid === obj.uid &&
                                                    item.index === key
                                                ) === index
                                            )
                                          : undefined
                                      }
                                      multiple={false}
                                    >
                                      <Button icon={<UploadOutlined />}>
                                        เลือกไฟล์
                                      </Button>
                                    </Upload>
                                  </Form.Item>

                                  <Col span={24} style={{ paddingTop: 10 }}>
                                    <Text
                                      style={{
                                        fontSize: 14,
                                        fontWeight: 500,
                                        color: "#667085",
                                      }}
                                    >
                                      สามารถ Upload File ได้ 1 File
                                      รองรับนามสกุล JPG, PDF ขนาดไม่เกิน 50 Mb
                                    </Text>
                                  </Col>
                                </Col>

                                <Col className="gutter-row" span={24}>
                                  <Form.Item
                                    {...restField}
                                    label="Note"
                                    name={[name, "staffFollowUp"]}
                                  >
                                    <Input.TextArea placeholder="รายละเอียด" />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        ))}
                        <ConfirmModal
                          actionType={"delete"}
                          title={"ยืนยันการลบข้อมูล"}
                          modalText={"คุณต้องการลบข้อมูล ?"}
                          open={
                            confirmModal.type === "delete"
                              ? confirmModal.show
                              : false
                          }
                          onOk={() => {
                            remove(confirmModal.name);
                            setConfirmModal({
                              type: "",
                              show: false,
                              name: "",
                            });
                          }}
                          onCancel={() => {
                            setConfirmModal({
                              type: "",
                              show: false,
                              name: "",
                            });
                          }}
                        />
                        <Col span={24}>
                          <Button
                            style={{
                              background: "#2E90FA",
                              color: "#fff",
                              fontWeight: 500,
                            }}
                            onClick={() => newCF()}
                          >
                            <PlusOutlined /> เพิ่ม
                          </Button>
                        </Col>{" "}
                      </>
                    );
                  }}
                </Form.List>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal
        open={failModal}
        setOpen={setFailModal}
        setErrMsg={() => setFailModal(false)}
      />
    </WithSidebar>
  );
};

export default EditStakeholder;
